import { always } from 'ramda'
import { createReducer } from '../../utilities/miscellaneous'

// initial state
export const INITIAL_STATE = {
  error: false,
  isBuffering: false,
  isLoading: false,
  isPlaying: false,
  // 0 <= n <= 100
  volume: 100,
  muted: false,
}

// action types
export const CLEAN = 'brightcove-radio/CLEAN'
export const INIT_PLAYER = 'brightcove-radio/INIT_PLAYER'
export const PLAYER_READY = 'brightcove-radio/PLAYER_READY'
export const PLAY = 'brightcove-radio/PLAY'
export const STARTED = 'brightcove-radio/STARTED'
export const PAUSE = 'brightcove-radio/PAUSE'
export const PAUSED = 'brightcove-radio/PAUSED'
export const SET_VOLUME = 'brightcove-radio/SET_VOLUME'
export const VOLUME_SET = 'brightcove-radio/VOLUME_SET'
export const TOGGLE_MUTE = 'brightcove-radio/TOGGLE_MUTE'
export const MUTED = 'brightcove-radio/MUTED'
export const UNMUTED = 'brightcove-radio/UNMUTED'
export const ERROR = 'brightcove-radio/ERROR'

// initPlayer :: () -> Action
export const initPlayer = always({ type: INIT_PLAYER })

// playerReady :: BrightcovePlayer -> Action
export const playerReady = player => ({
  type: PLAYER_READY,
  player,
})

// play :: () -> Action
export const play = always({ type: PLAY })

// started :: () -> Action
export const started = always({ type: STARTED })

// pause :: () -> Action
export const pause = always({ type: PAUSE  })

// paused :: () -> Action
export const paused = always({ type: PAUSED })

// setVolume :: Decimal -> Action
export const setVolume = level => ({
  type: SET_VOLUME,
  level: Number(level),
})

// volumeSet :: () -> Action
export const volumeSet = always({ type: VOLUME_SET })

// toggleMute :: Boolean -> Action
export const toggleMute = shouldMute => ({
  type: TOGGLE_MUTE,
  shouldMute,
})

// muted :: () -> Action
export const muted = always({ type: MUTED })

// unmuted :: () -> Action
export const unmuted = always({ type: UNMUTED })

// clean :: () -> Action
export const clean = always({ type: CLEAN })

// error :: () -> Action
export const error = always({ type: ERROR })

// LiveRadio :: (State, Action *) -> State
export default createReducer(INITIAL_STATE, {
  [CLEAN]: always(INITIAL_STATE),

  [INIT_PLAYER]: state => ({
    ...state,
    isLoading: true,
  }),

  [PLAYER_READY]: state => ({
    ...state,
    isLoading: false,
  }),

  [PLAY]: state => ({
    ...state,
    isBuffering: true,
    error: false,
  }),

  [STARTED]: state => ({
    ...state,
    isBuffering: false,
    isPlaying: true,
  }),

  [PAUSED]: state => ({
    ...state,
    isPlaying: false,
  }),

  [SET_VOLUME]: (state, { level }) => ({
    ...state,
    volume: level,
  }),

  [MUTED]: state => ({
    ...state,
    muted: true,
  }),

  [UNMUTED]: state => ({
    ...state,
    muted: false,
  }),

  [ERROR]: state => ({
    ...state,
    isPlaying: false,
    isBuffering: false,
    error: true,
  }),
})
